module.exports = __webpack_public_path__ + "img/ck.c4624260.svg";